import script from "./VerifikasiDataImkpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifikasiDataImkpPage.vue?vue&type=script&setup=true&lang=js"

import "./VerifikasiDataImkpPage.vue?vue&type=style&index=0&id=e999bc98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e999bc98"]])

export default __exports__